import { Resource } from 'i18next';
import { locale as enUs } from 'translations/locales/en-us';

export const resources: Resource = {
  'en-US': enUs,
};
